export interface UserWalletModel {
  id: number;
  address: string;
  dateCreated: string;
  status: UserWalletStatus;
  label: string;
  isFlipme: boolean;
}

export enum UserWalletStatus {
  ACTIVATED = 1,
  DEACTIVATED
}

export interface DeleteUserWalletResponse {
  isDeleted: boolean;
}

export interface UpdateUserWalletResponse {
  userWallet: UserWalletModel;
}

interface KycStatusModel {
  isAddressAdded: boolean;
  isWalletAdded: boolean;
  isDocumentAdded: boolean;
  isSelfieAdded: boolean;
  isKycCompleted: boolean;
  isAllCompleted: boolean;
  selfieImageUrl: string;
  documentImageUrls: string[];
  documentType: number;
  documentHolder: string;
  isKycVerified: boolean;
  arePersonalDetailsAdded: boolean;
  areTermsAccepted: boolean;
}

export interface AddUserWalletResponse {
  userWallet: UserWalletModel;
  kycStatus: KycStatusModel;
}

export interface GetUserWalletsResponse {
  userWallets: UserWalletModel[];
}
